<template>
  <a :href="`#section-${item.sectionIndex}`"
     :data-id="item.id"
     :data-item-index="item.index"
     :data-section-index="item.sectionIndex"
     class="scrollactive-item sidebar-link"
     @click="onClick">
    <div v-if="item.value.flight" class="first-line">
      <span>{{ flightNum }}</span>
      <span>{{ item.value.flight.info.time }}</span>
      <span>{{ depDateLabel }}</span>
    </div>
    <div v-if="item.value.flight">{{ item.value.flight.depPortLabels.label }} - {{ item.value.flight.arrPortLabels.label }}</div>
    <div v-else>{{ $t('flights.without') }}</div>
  </a>
</template>

<script>
import moment from 'moment'

export default {
  props: ['item', 'index'],

  computed: {
    depDateLabel () {
      return moment(this.item.value['flight.flightDate']).utc(true).format('YYYY-MM-DD')
    },
    flightNum () {
      if (!this.item.value.flight) {
        return ''
      }
      return this.item.value.flight.ak + (this.item.value.flight.info.flightNum || '---')
    }
  },
  methods: {
    onClick () {
      this.debug && console.log('group item: %o', this.item)
      this.$emit('click:item', this.item)
    }
  }
}
</script>

<style scoped>
  .first-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/GroupFlight.vue